export const kebabToScreamingSnake = input => {
  if (!input || typeof input !== 'string') {
    return '';
  }
  return input.trim().replace(/-/g, '_').toUpperCase();
};